import { Box, Typography } from "@mui/material"

const LearnMore = () => {
    return(
        <Box sx={{ pt: {xs: 5, md: 15}, px: {xs: 4, md: 20}, mb: {xs: 4, md: 0}, textAlign: "left", gap: '20px',  }}>
            <Box sx={{mb: 6}}>
                <Typography variant="h3" gutterBottom sx={{ lineHeight: "60px", width:{ xs: "100%", md: "40%"}}} >
                Learn more about Vivek Bio Products
                </Typography>
            </Box>
            <Box sx={{ display:{xs: "block", md: "flex"}}} gap={4} mb={4}>
                <Box sx={{flex: "1 1", mb: {xs: 4, md: 0}}}>
                    <Typography flex='1 1' fontWeight="bold" variant="subtitle1" margin='auto'>
                    Vivek Bio-Products Private Limited: Transforming Energy and Empowering Communities Company Overview
                    </Typography>
                    <Typography flex='1 1' variant="subtitle1" margin='auto'>
                    Vivek Bio-Products Private Limited is establishing an advanced 120 KLPD Grain-Based Ethyl Alcohol (Biofuel) Distillery in Kamareddy District, Telangana, strategically positioned in Southern India. This initiative supports the Union Government's Biofuel Blending Programme, which aims to reduce India’s dependency on fossil fuels and promote renewable energy. The primary output, Bio Fuel, will be supplied to Oil Marketing Companies, contributing to national energy security and environmental sustainability.
                    </Typography>
                </Box>
                <Box sx={{ flex: "1 1"}}>
                    <Typography flex='1 1' fontWeight="bold" variant="subtitle1" margin='auto'>
                    Innovative Byproduct Utilization
                    </Typography>
                    <Typography flex='1 1' variant="subtitle1" margin='auto'>
                    In addition to producing Bio Fuel, the plant will generate Dry Distilled Grain Solubles (DDGS), a highprotein byproduct that serves as an essential ingredient in animal and poultry feed. This not only optimizes resource utilization but also addresses key nutritional challenges in livestock farming, making DDGS a sustainable solution with significant economic value.
                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display:{xs: "block", md: "flex"}}} gap={3}>
                <Box sx={{ mb: {xs: 4, md: 0} }}>
                    <Typography flex='1 1' fontWeight="bold" variant="subtitle1" margin='auto'>
                    Commitment to Farmer Empowerment
                    </Typography>
                    <Typography flex='1 1' variant="subtitle1" margin='auto'>
                    The company’s mission extends far beyond energy production. By sourcing raw materials directly from farmers, it ensures fair compensation and provides consistent demand for agricultural produce. This approach uplifts rural communities, enhances farmers' incomes, and fosters long-term sustainability in agriculture, thus revitalizing local economies and strengthening rural India.
                    </Typography>
                </Box>
                <Box>
                    <Typography flex='1 1' fontWeight="bold" variant="subtitle1" margin='auto'>
                    Environmental Impact
                    </Typography>
                    <Typography flex='1 1' variant="subtitle1" margin='auto'>
                    Vivek Bio-Products is dedicated to supporting India’s environmental goals. The production of Bio Fuel reduces reliance on crude oil imports, leading to significant foreign exchange savings and a lower national oil import bill. Furthermore, biofuel use decreases greenhouse gas emissions, playing a critical role in combating climate change and reducing the country’s carbon footprint.
                    </Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default LearnMore;